import React, { Component } from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import FormAlumno from "./FormAlumno";
import { getAlumnoDetail, putAlumnoUpdate } from "./AlumnoAction";
import swal from "sweetalert";
import { withRouter } from 'react-router-dom';

import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import { Link } from "react-router-dom";

import getMuiTheme from 'material-ui/styles/getMuiTheme'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

const mapStateToProps = (state) => {
    return {
        getResponDataAlumno: state.AlumnoReducer.getResponDataAlumno,
        errorResponDataAlumno: state.AlumnoReducer.errorResponDataAlumno,
    };
};

class AlumnoEditContainer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

    componentDidMount() {
        this.props.dispatch(getAlumnoDetail(this.props.match.params.id));
    }

    handleSubmit(data) {
        this.props.dispatch(putAlumnoUpdate(data, this.props.match.params.id));
    }

	render() {
		const { activeTab } = this.state

		if (this.props.getResponDataAlumno || this.props.errorResponDataAlumno) {

            if (this.props.errorResponDataAlumno) {
                swal("Fallido!", this.props.errorResponDataAlumno, "Error");
            } else {
				swal({
					title: "¡Alumno Actualizado!",
					icon: "success",
					button:"Enterado"
					}
                )
                .then((willDelete) => {
					this.props.history.push("/alumno");
                });
			}//END ELSE

        }//END IF

		return (
			<MuiThemeProvider muiTheme={getMuiTheme()}>
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Alumno</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Escolar</a></li>
									<li className="breadcrumb-item active" aria-current="page">Editar</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								<NavItem>
									<Link to={"/alumno"}>Listar Alumno</Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								

								<div className="row clearfix">
									<div className="col-lg-12 col-md-12 col-sm-12">
										<div className="card">
											<div className="card-header">
												<h3 className="card-title">Editar Alumno IEC</h3>
												<div className="card-options ">
													<a href="#" className="card-options-collapse" data-toggle="card-collapse"><i className="fe fe-chevron-up"></i></a>
													<a href="#" className="card-options-remove" data-toggle="card-remove"><i className="fe fe-x"></i></a>
												</div>
											</div>

											<FormAlumno onSubmit={(data) => this.handleSubmit(data)} />

										</div>
									</div>

								</div>

							</TabPane>


						</TabContent>
					</div>
				</div>

			</>
			</MuiThemeProvider>
		);

    }// END RENDER

} //END AlumnoEditContainer

export default withRouter(connect(mapStateToProps, null)(AlumnoEditContainer));
